import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiChamiliApostrofos';
const args = {};

export class PetastiChamiliApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
